﻿import jquery from 'jquery';
import HabEvents from '../Global/habitaclia-events';

class ModuloLider {
    constructor(moduloLiderDto) {
        this.moduloLiderDto = moduloLiderDto;
        this.timeoutajax = 15000;
        this.configurations = {
            mobile: {
                selectorContainer: '#ajaxModuloLider',
                selectorImages: '#ajaxModuloLider .loadImg',
                classShow: 'mostrar',
                classHide: 'ocultar',
                registerEventsClick: true
                
            },
            desktop: {
                selectorContainer: '#ajaxModuloLider',
                selectorImages: '#ajaxModuloLider .loadImg',
                classShow: 'mostrar',
                classHide: 'ocultar',
                registerEventsClick: false
            }
        };

        this.configName = this.__getConfigName(this.moduloLiderDto.configName);

        this.__$ajaxModuloLider = jquery(this.configurations[this.configName].selectorContainer);

        this.__initCallAjaxLider();
    }

    __getConfigName(configName) {
        if (configName) {
            return configName;
        }

        return 'mobile';
    }

    __initCallAjaxLider () {
        if (!!this.moduloLiderDto.urlModuloLider) {
            const urlModuloLider = this.moduloLiderDto.urlModuloLider;
            const dataModuloLider = `p=${this.moduloLiderDto.NavParamsLista.p}${this.moduloLiderDto.filtrosSerializados}`; 

            jquery.ajax({
                url: urlModuloLider,
                type: 'POST',
                data: dataModuloLider,
                dataType: 'html',
                timeout: this.timeoutajax,
                success: (data) => {
                    this.__mostrarModuloLider(data);
                },
                error: (jqXhr, textStatus, errorThrown) => {
                    this.__ocultarModuloLider();
                    const msg = `Error MostrarModuloLider carga en segundo plano: responseText: ${jqXhr.responseText} textStatus: ${textStatus} errorThrown: ${errorThrown}`;
                    throw msg;
                }
            });

        } else {
            this.__$ajaxModuloLider.remove();
        }
    }

    __loadImagesModuloLider() {

        const images = jquery(this.configurations[this.configName].selectorImages);

        for (let i = 0; i < images.length; i++) {
            const image = images[i];

            if (image.name.length > 0) {
                image.src = image.name;
                image.name = '';
            }
        }
    }

    __ocultarModuloLider() {
        this.__$ajaxModuloLider.remove();
        jquery.publish(HabEvents.EventsEnum.ModuloLiderNoCargado);
    }

    __mostrarModuloLider(data) {
        if (data.length > 0) {
            this.__$ajaxModuloLider.html(data);
            this.__$ajaxModuloLider.css('display', '');
            this.__$ajaxModuloLider.removeClass(this.configurations[this.configName].classHide).addClass(this.configurations[this.configName].classShow);
        } else {
            this.__ocultarModuloLider();
        }

        this.__loadImagesModuloLider();

        if (this.configurations[this.configName].registerEventsClick) {
            this.__registerEventsLider();
        }
        
        jquery.publish(HabEvents.EventsEnum.ModuloLiderCargado);
    }

    __registerEventsLider() {
        jquery('.gtmlistproductviewdestacado').click((e) => {
            var url = e.currentTarget.getAttribute('data-url');
            window.location = url;
        });

        jquery('.gtmclickpromolider').click(() => {
            window.location = jquery('.botoninmobiliarialider a').attr('href');
        });
    }
}

export default ModuloLider;